import DebugController from '@/glxp/debug/debugController'

class Settings {
  constructor () {
    this.overlay_cover = { value: 0.8, range: [0, 1] }
    DebugController.addConfig(this, 'General')
  }
}

const out = new Settings()
export default out
